import connectToStores from "alt-utils/lib/connectToStores";
import PersonStore from "../app/stores/PersonStore";
import PersonActions from "../app/actions/PersonActions";

@connectToStores
class LoginWidget extends React.Component {
  static getStores() {
    return [PersonStore];
  }

  static getPropsFromStores() {
    return PersonStore.getState();
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  componentDidMount() {
    // Open modal if we are mid-login-sequence for a social login
    if (
      window.location.search.indexOf("eventival_auth=true") !== -1 &&
      !this.context.router.isActive({ pathname: "/login" })
    ) {
      try {
        const query = Object.fromEntries(
          new URLSearchParams(window.location.search)
        );
        this.context.router.push({ pathname: "/login", query });
      } catch (e) {
        // fall through, unsupported browser features
      }
    }
  }

  render() {
    if (!this.props.isLoggedIn) {
      return (
        <a
          href="#login"
          onClick={e => {
            e.preventDefault();
            this.context.router.push("/login");
          }}
        >
          {this.props.loginButtonText || "Log in to your account"}
        </a>
      );
    } else {
      return (
        <span>
          <span className="Eventive--LoginWidget--LoginDescription">
            Logged in as {this.props.details.name || this.props.details.email}.
          </span>{" "}
          <a
            href="#logout"
            onClick={e => {
              e.preventDefault();
              PersonActions.logout();
            }}
          >
            {this.props.logoutButtonText || "Log out"}
          </a>
        </span>
      );
    }
  }
}

export default LoginWidget;



// WEBPACK FOOTER //
// ./src/widget/login-widget.jsx